// Synthesized crystal chime via Web Audio API — no audio asset needed.
// Grounded in expressive-arts / music therapy: gentle, consonant, decaying
// bell tones provide soothing multisensory feedback and a sense of "containment".
let ctx = null;

export const isSoundOn = () => localStorage.getItem("sound_off") !== "1";
export const setSoundOn = (on) => localStorage.setItem("sound_off", on ? "0" : "1");

export function playCrystal() {
  if (!isSoundOn()) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;

    const master = ctx.createGain();
    master.gain.value = 0.9;
    master.connect(ctx.destination);

    // Pentatonic scale (C major pentatonic across octaves) — always consonant,
    // so every random pick still sounds like flowing crystal music.
    const scale = [
      523.25, 587.33, 659.25, 783.99, 880.0,      // C5 D5 E5 G5 A5
      1046.5, 1174.66, 1318.51, 1567.98, 1760.0,  // C6 D6 E6 G6 A6
      2093.0,                                      // C7
    ];
    const root = scale[Math.floor(Math.random() * scale.length)];
    // random shimmering partials above the root
    const ratios = [1, 1.5, 2, 3].filter(() => Math.random() > 0.25);
    if (!ratios.includes(1)) ratios.unshift(1);
    const decay = 0.9 + Math.random() * 0.6;
    const detune = (Math.random() - 0.5) * 6;

    ratios.forEach((r, i) => {
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = root * r;
      osc.detune.value = detune;
      const gain = ctx.createGain();
      const peak = (0.17 / (i + 1)) * (0.8 + Math.random() * 0.4);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(peak, now + 0.006);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + decay);
      osc.connect(gain);
      gain.connect(master);
      osc.start(now);
      osc.stop(now + decay + 0.05);
    });
  } catch (e) {
    /* audio not available */
  }
}
